import React from "react";
import PropTypes from "prop-types";
import { Tag } from "antd";

const PropertyImportIndicator = ({ enabled, isImported, t }) =>
  enabled && isImported === true ? (
    <Tag className="text-capitalize property-list-badge" color="blue">
      {t("PropertiesTable.Imported")}
    </Tag>
  ) : null;

PropertyImportIndicator.propTypes = {
  enabled: PropTypes.bool,
  isImported: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

PropertyImportIndicator.defaultProps = { enabled: true };

export default PropertyImportIndicator;
